module.exports = __webpack_public_path__ + "static/drumster-hero@2x-min-ee8b9236931641e318d559938a1d73f7.png";